import ScrollObserver from "./ScrollObserver";
import { inview } from "./inview";

import moment from "moment/moment";

export const getFeed = () => {
  window.addEventListener("DOMContentLoaded", async () => {
    const feed_url = "https://nabe8-nousan.amebaownd.com/rss.xml?categoryId=7414336";

    var res = await fetch(`https://api.rss2json.com/v1/api.json?rss_url=${feed_url}`);

    var data = await res.json();

    // console.log(data);

    var counter = 0;

    const $posts = document.querySelector("#top-newslist");

    data.items.forEach((item) => {
      // console.log(item);
      if (counter < 3) {
        const pubDatetime = item.pubDate;
        const pubDate = moment(pubDatetime).format("YYYY年MM月DD日");
        // var pubDate = pubDatetime.substring(0, pubDatetime.indexOf(" "));
        // pubDate = pubDate.replace(/-/g, "/");

        var $post = document.createElement("article");
        $post.classList.add("p-top-news_item");
        $post.classList.add("js-scroll");
        $post.setAttribute("data-animation", "fadeup");
        $post.innerHTML = `
        <p class="title"><a href="${item.link}" target="_blank" rel="noopenner noreferrer">${item.title}</a></p>
        <p class="datetime"><time datetime="${pubDatetime}">${pubDate}</time></p>
        `;
        $posts.appendChild($post);

        ++counter;
      }
    });

    // scroll
    // ----------------------------
    const fadeAnimation = new ScrollObserver(".js-scroll", inview, {
      once: true,
      rootMargin: "0% 0% 0px",
    });
  });
};
